/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

AlertboxId = 0;

Alertbox = function(infos) {
    AlertboxId++;

    var html = '';
    html += '<div class="row no-gutters alertbox-row">';
    html += '<div class="alertbox ' + infos.type + '">';

    html += '<div class="row no-gutters">';

    html += '<div class="col-md-3 d-none d-md-block">';
    html += '<div class="image-wrapper"><div class="image"></div></div>';
    html += '</div>';

    html += '<div class="col-md-9 col-12">';
    html += '<div class="content">';

    html += '<div class="row no-gutters title-row">'

    html += '<div class="col-auto">';
    html += '<div class="title">' + infos.title + '</div>';
    html += '</div>';

    html += '<div class="col-auto ml-auto">';
    html += '<div class="close" onclick="$.fancybox.close();"><i class="far fa-times-circle"></i></div>';
    html += '</div>';

    html += '</div>';

    html += '<div class="row no-gutters mt-3">'

    html += '<div class="col-12">';
    html += '<div class="content-text">' + infos.content + '</div>';
    html += '</div>';

    html += '</div>';

    html += '</div>';
    html += '</div>';

    html += '</div>';

    html += '</div>';
    html += '</div>';

    $.fancybox.open(html, {
        closeBtn: false,
        speed: 800
    });
};

/**
 * BBCode helpers
 */
$(document).ready(function() {
    $(".colorpicker-btn").each(function(index, el) {
        var receiver = $(this).data('receiver');

        $(this).ColorPicker({
            'color': '#009FF',
            onShow: function(colpkr) {
                $(colpkr).fadeIn(500);
                return false;
            },
            onHide: function(colpkr) {
                $(colpkr).fadeOut(500);
                selTexto(receiver, '[color=#' + colpkr_color + ']', '[/color]');

                return false;
            },
            onChange: function(hsb, hex, rgb) {
                colpkr_color = hex;
            }
        });
    });
});

$(document).on('click', '.bbcode-insert', function() {
    var tag = $(this).data('bbcode');
    var close = $(this).data('bbcode-close');
    var receiver = $(this).data('receiver');

    var closeTag = "/" + tag;

    if (close) {
        closeTag = "/" + close;
    }

    selTexto(receiver, "[" + tag + "]", "[" + closeTag + "]");
});

function selTexto(obj, antes, depois) {
    var selecionado = selecao(obj, true);
    selecionado.defTexto(antes + selecionado.text + depois);
}

function selecao(obj, def_texto_padrao) {
    if (obj.constructor == String) {
        obj = document.getElementById(obj);
    }

    var def_texto = (def_texto_padrao) ? function(text) {
        obj.value += text;
    } : function() {
        return false;
    };
    var selecao = {
        text: "",
        defTexto: def_texto
    };

    if (document.selection) {
        var faixa = document.selection.createRange();

        if (faixa.text) {
            selecao.text = faixa.text;

            selecao.defTexto = function(text) {
                faixa.text = text.replace(/\r?\n/g, "\r\n");
            };
        }
    } else if (typeof(obj.selectionStart) != "undefined") {
        selecao.text = obj.value.substring(obj.selectionStart, obj.selectionEnd);

        selecao.defTexto = function(text) {
            obj.value = obj.value.substring(0, obj.selectionStart) + text + obj.value.substring(obj.selectionEnd);
            return false;
        };
    } else if (window.getSelection) {
        selecao.text = window.getSelection().toString();
    }

    return selecao;
}

function split(val) {
    return val.split(/ \s*/);
}

function extractLast(term) {
    return split(term).pop();
}
